var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SIZE_CLASSES, DEFAULT_SIZE_CLASS } from './size-class';
import { BASELINE_GRID } from './baseline-grid';
export var sizeClassFromWidth = function (width) {
    if (!width) {
        return DEFAULT_SIZE_CLASS;
    }
    if (width < SIZE_CLASSES.SMALL.value) {
        return SIZE_CLASSES.EXTRA_SMALL;
    }
    else if (width < SIZE_CLASSES.MEDIUM.value) {
        return SIZE_CLASSES.SMALL;
    }
    else if (width < SIZE_CLASSES.LARGE.value) {
        return SIZE_CLASSES.MEDIUM;
    }
    else if (width < SIZE_CLASSES.EXTRA_LARGE.value) {
        return SIZE_CLASSES.LARGE;
    }
    else if (width < SIZE_CLASSES.EXTRA_EXTRA_LARGE.value) {
        return SIZE_CLASSES.EXTRA_LARGE;
    }
    return SIZE_CLASSES.EXTRA_EXTRA_LARGE;
};
/*
This is faster than inspecting widths, but it can be very imprecise
*/
var sizeClassFromBaselineCols = function (baselineCols) {
    if (baselineCols <= BASELINE_GRID.EXTRA_SMALL.MAX) {
        return SIZE_CLASSES.EXTRA_SMALL;
    }
    if (baselineCols <= BASELINE_GRID.SMALL.MAX) {
        return SIZE_CLASSES.SMALL;
    }
    if (baselineCols <= BASELINE_GRID.MEDIUM.MAX) {
        return SIZE_CLASSES.MEDIUM;
    }
    // unable to distinguish LARGE from EXTRA_LARGE or EXTRA_EXTRA_LARGE looking at baselineCols alone
    return SIZE_CLASSES.LARGE;
};
var measureWidth = function (widthRef) {
    if (widthRef.current) {
        return widthRef.current.offsetWidth;
    }
};
export var actions = {
    onResize: function (layoutContextState, resizeObserverWidth) {
        var widthRef = layoutContextState.widthRef, baselineColumns = layoutContextState.baselineColumns;
        var measuredWidth = resizeObserverWidth ? resizeObserverWidth : measureWidth(widthRef);
        if (measuredWidth !== undefined) {
            return __assign(__assign({}, layoutContextState), { sizeClass: sizeClassFromWidth(measuredWidth), width: measuredWidth });
        }
        if (baselineColumns !== null) {
            return __assign(__assign({}, layoutContextState), { sizeClass: sizeClassFromBaselineCols(baselineColumns) });
        }
        return layoutContextState;
    },
    onMediaQueryMatchChange: function (layoutContextState, useViewportMediaQueries, viewportMediaQuerySizeClass, viewportMediaQueryBaselineColumns) {
        if (useViewportMediaQueries && viewportMediaQuerySizeClass && viewportMediaQueryBaselineColumns) {
            return __assign(__assign({}, layoutContextState), { sizeClass: viewportMediaQuerySizeClass, baselineColumns: viewportMediaQueryBaselineColumns, isInGrid: false });
        }
        return layoutContextState;
    },
    onPropChange: function (layoutContextState, props) {
        var baselineColumns = props.baselineColumns, isInGrid = props.isInGrid, isInManagedLayout = props.isInManagedLayout, sizeClass = props.sizeClass, widthRef = props.widthRef;
        var update = {};
        if (baselineColumns && baselineColumns !== layoutContextState.baselineColumns) {
            update.baselineColumns = baselineColumns;
        }
        if (isInGrid !== undefined && isInGrid !== layoutContextState.isInGrid) {
            update.isInGrid = isInGrid;
        }
        if (isInManagedLayout !== undefined && isInManagedLayout !== layoutContextState.isInManagedLayout) {
            update.isInManagedLayout = isInManagedLayout;
        }
        if (sizeClass && sizeClass !== layoutContextState.sizeClass) {
            update.sizeClass = sizeClass;
        }
        if (widthRef && widthRef !== layoutContextState.widthRef) {
            update.widthRef = widthRef;
        }
        return Object.keys(update).length === 0 ? layoutContextState : __assign(__assign({}, layoutContextState), update);
    },
};
export var layoutContextReducer = function (layoutContextState, action) {
    var type = action.type, inputs = action.inputs;
    switch (type) {
        case 'onResize': {
            var resizeObserverWidth = inputs.resizeObserverWidth;
            return actions.onResize(layoutContextState, resizeObserverWidth);
        }
        case 'onMediaQueryMatchChange': {
            var useViewportMediaQueries = inputs.useViewportMediaQueries, viewportMediaQuerySizeClass = inputs.viewportMediaQuerySizeClass, viewportMediaQueryBaselineColumns = inputs.viewportMediaQueryBaselineColumns;
            return actions.onMediaQueryMatchChange(layoutContextState, useViewportMediaQueries, viewportMediaQuerySizeClass, viewportMediaQueryBaselineColumns);
        }
        case 'onPropChange': {
            var baselineColumns = inputs.baselineColumns, isInGrid = inputs.isInGrid, isInManagedLayout = inputs.isInManagedLayout, sizeClass = inputs.sizeClass, widthRef = inputs.widthRef;
            return actions.onPropChange(layoutContextState, {
                baselineColumns: baselineColumns,
                isInGrid: isInGrid,
                isInManagedLayout: isInManagedLayout,
                sizeClass: sizeClass,
                widthRef: widthRef
            });
        }
        default: {
            return layoutContextState;
        }
    }
};
//# sourceMappingURL=layout-context-state.js.map